import React from 'react';

function VacationStats({ employees, onShowList }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const in30Days = new Date(today);
  in30Days.setDate(in30Days.getDate() + 30);

  const currentlyInVacation = employees.filter((e) => {
    if (!e.vacation_start || !e.vacation_end) return false;
    const start = new Date(e.vacation_start);
    const end = new Date(e.vacation_end);
    return start <= today && end >= today;
  });

  const goingSoon = employees.filter((e) => {
    if (!e.vacation_start) return false;
    const start = new Date(e.vacation_start);
    return start > today && start <= in30Days;
  });

  const comingBackSoon = employees.filter((e) => {
    if (!e.vacation_end) return false;
    const end = new Date(e.vacation_end);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return end >= yesterday && end <= in30Days;
  });

  return (
    <div
      className="vacation-card vacation-compact"
      title="Показать списки"
    >
      <div className="vacation-icon">🏖</div>
      <div className="vacation-compact-body">
        <div
          className="vacation-compact-row"
          onClick={() => onShowList('now')}
        >
          <span className="vacation-compact-label">Сейчас в отпуске:</span>
          <span className="vacation-compact-value">{currentlyInVacation.length}</span>
        </div>
        <div className="vacation-compact-inline">
          <div
            className="vacation-compact-row small"
            onClick={() => onShowList('soon')}
          >
            <span className="vacation-compact-label">📅 Скоро уходят:</span>
            <span className="vacation-compact-value small">{goingSoon.length}</span>
          </div>
          <div
            className="vacation-compact-row small"
            onClick={() => onShowList('back')}
          >
            <span className="vacation-compact-label">↩️ Возвращаются:</span>
            <span className="vacation-compact-value small">{comingBackSoon.length}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VacationStats;